import { Avatar, Button, ListItem, Modal } from "@design";
import { useTranslation } from "react-i18next";
import type { SpaceHubResponse } from "@/api";
import { Text } from "@/components/Text";

const initials = (name: string) =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");

/** Placeholder members list (read-only) until there's a design. */
export function SpaceMembersDialog({ space, onClose }: Readonly<{ space: SpaceHubResponse; onClose: () => void }>) {
  const { t } = useTranslation("spaces", { keyPrefix: "detail" });
  return (
    <Modal
      open
      onClose={onClose}
      title={t("members")}
      actions={
        <Button variant="secondary" onClick={onClose}>
          {t("placeholder.close")}
        </Button>
      }
    >
      <ul>
        {(space.members ?? []).map((m) => (
          <li key={m.userUuid}>
            <ListItem
              flat
              leading={<Avatar initials={initials(m.name)} size="sm" />}
              description={m.email}
              trailing={
                <Text as="span" variant="caption" tone="tertiary">
                  {m.role}
                </Text>
              }
            >
              {m.name}
            </ListItem>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
